import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {passwordResetStates} from 'modules/authentication/constants';
import {resetStateSelector} from 'modules/authentication/selectors';
import {setTitle} from 'modules/a11ycat/actions';

import ForgottenPassword from './Steps/ForgottenPassword';
import ForgottenPasswordCode from './Steps/ForgottenPasswordCode';
import ResetPassword from './Steps/ResetPassword';
import ResetResult from './Steps/ResetResult';

export default function PasswordReset() {

    const dispatch = useDispatch();
    const step = useSelector(resetStateSelector);

    let resetStep;
    let pageTitle;
    switch (step) {
        case passwordResetStates.ENTER_EMAIL:
            resetStep = <ForgottenPassword/>;
            pageTitle = 'Password Reset - Enter Email';
            break;
        case passwordResetStates.ENTER_CODE:
            resetStep = <ForgottenPasswordCode/>;
            pageTitle = 'Password Reset - Enter Code';
            break;
        case passwordResetStates.ENTER_PASSWORDS:
            resetStep = <ResetPassword/>;
            pageTitle = 'Password Reset - Enter Passwords';
            break;
        case passwordResetStates.RESET_SUCCESS:
            resetStep = <ResetResult>
                <p>Your password has been reset successfully.</p>
                <p>Please continue to the login page to authenticate.</p>
            </ResetResult>;
            pageTitle = 'Password Reset - Success';
            break;
        case passwordResetStates.RESET_FAILED:
            resetStep = <ResetResult>
                <p>Your password failed to reset.</p>
                <p>Please try again.</p>
            </ResetResult>;
            pageTitle = 'Password Reset - Failed';
            break;
        case passwordResetStates.RESET_CANCELLED:
            resetStep = <ResetResult>
                <p>Your password reset request has been cancelled.</p>
            </ResetResult>;
            pageTitle = 'Password Reset - Cancelled';
            break;
    }

    useEffect(() => {
        if (pageTitle) {
            dispatch(setTitle(pageTitle));
        }
    }, [pageTitle]);

    return <>{resetStep}</>;
}